import apiFetch from '../apiFetch'

export default function (list, token) {
  return apiFetch({endPoint: `GrupoVerraco/getDeleteSeleccion`, method: 'POST', body: {list}, token: token})
}
